var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderDetail" },
    [
      _c("div", { staticClass: "banxin" }, [
        _c(
          "div",
          { staticClass: "head" },
          [
            _c("router-link", { attrs: { to: "/myOrder" } }, [
              _c("div", { staticClass: "mar-right-10" }, [_vm._v("我的订单")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "arrow" }),
            _vm._v(" "),
            _c("div", { staticClass: "mar-right-10" }, [_vm._v("订单详情")])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "status" }, [
          _c("div", { staticClass: "left" }, [
            _c("p", { staticClass: "fs16 fw-blod mar-top-20 mar-bot-60" }, [
              _vm._v("订单号：" + _vm._s(_vm.orderDetail.orderFormid))
            ]),
            _vm._v(" "),
            _vm.orderDetail.state == 1
              ? _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c(
                      "p",
                      { staticClass: "fs24 fw-blod mar-bot-10 font-color-71B" },
                      [_vm._v("等待付款")]
                    ),
                    _vm._v(" "),
                    _vm.orderDetail.collageId == 0
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "time fs12 mar-bot-10 font-color-999 flex-items"
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "13px",
                                height: "13px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                src: require("../../../static/image/alarm_clock@2x.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(
                              " 剩余时间" +
                                _vm._s(_vm._f("formatMinutes")(_vm.endTime)) +
                                "分"
                            )
                          ]
                        )
                      : _c(
                          "p",
                          {
                            staticClass:
                              "time fs12 mar-bot-10 font-color-999 flex-items"
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "13px",
                                height: "13px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                src: require("../../../static/image/alarm_clock@2x.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(
                              " 剩余时间" +
                                _vm._s(_vm._f("formatMinutes")(_vm.endTime1)) +
                                "分"
                            )
                          ]
                        ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "cancel mar-bot-10",
                        attrs: { plain: "", size: "small" },
                        on: { click: _vm.closeOrder }
                      },
                      [_vm._v("取消订单")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "pay mar-bot-10",
                        attrs: { plain: "", size: "small" },
                        on: { click: _vm.getUrl }
                      },
                      [_vm._v("付款")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.orderDetail.state == 6 ||
            (_vm.orderDetail.collageId != 0 &&
              _vm.orderDetail.paymentState == 1) ||
            (_vm.orderDetail.collageId != 0 && _vm.orderDetail.state == 5)
              ? _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _vm.orderDetail.paymentState == 1 &&
                    _vm.groupData.state == 0
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "fs24 fw-blod mar-bot-10 font-color-FF7"
                          },
                          [_vm._v("等待成团")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.orderDetail.paymentState == 1 &&
                    _vm.groupData.state == 1
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "fs24 fw-blod mar-bot-10 font-color-FF7"
                          },
                          [_vm._v("拼团成功")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.orderDetail.state == 5 && _vm.groupData.state == 2
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "fs24 fw-blod mar-bot-10 font-color-red"
                          },
                          [_vm._v("拼团失败")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.orderDetail.paymentState == 1 &&
                    _vm.groupData.state == 0
                      ? _c(
                          "el-button",
                          {
                            staticClass: "invite mar-bot-10",
                            attrs: { plain: "", size: "small" },
                            on: { click: _vm.inviteFriends }
                          },
                          [_vm._v("邀请好友")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.groupData.state == 0
                      ? _c(
                          "el-button",
                          {
                            staticClass: "cancel mar-bot-10",
                            attrs: { plain: "", size: "small" },
                            on: { click: _vm.closeOrder }
                          },
                          [_vm._v("取消订单")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.groupData.state != 0
                      ? _c(
                          "el-button",
                          {
                            staticClass: "invite",
                            attrs: { plain: "", size: "small" },
                            on: { click: _vm.again }
                          },
                          [_vm._v("再次开团")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.orderDetail.state == 2 && _vm.orderDetail.collageId == 0
              ? _c("div", { staticClass: "box mar-top-40" }, [
                  _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("待发货")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orderDetail.state == 3 && _vm.orderDetail.collageId == 0
              ? _c("div", { staticClass: "box mar-top-40" }, [
                  _c(
                    "p",
                    { staticClass: "fs24 fw-blod mar-bot-10 font-color-FF7" },
                    [_vm._v("运输中")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orderDetail.state == 4 && _vm.orderDetail.collageId == 0
              ? _c("div", { staticClass: "box mar-top-40" }, [
                  _c(
                    "p",
                    { staticClass: "fs24 fw-blod mar-bot-10 font-color-71B" },
                    [_vm._v("已完成")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orderDetail.state == 5 && _vm.orderDetail.collageId == 0
              ? _c("div", { staticClass: "box mar-top-40" }, [
                  _c(
                    "p",
                    { staticClass: "fs24 fw-blod mar-bot-10 font-color-71B" },
                    [_vm._v("已关闭")]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right" },
            [
              _vm.orderDetail.state == 1 && _vm.orderDetail.collageId == 0
                ? _c("StatusOne", {
                    attrs: { createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 2 && _vm.orderDetail.collageId == 0
                ? _c("StatusTwo", {
                    attrs: { createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 3 && _vm.orderDetail.collageId == 0
                ? _c("StatusThree", {
                    attrs: { createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 4 && _vm.orderDetail.collageId == 0
                ? _c("StatusFour", {
                    attrs: {
                      receiveTime: _vm.orderDetail.receiveTime,
                      createTime: _vm.orderDetail.createTime
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 5 && _vm.orderDetail.collageId == 0
                ? _c("StatusFive", {
                    attrs: { createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 6 && _vm.orderDetail.collageId != 0
                ? _c("StatusSix", {
                    attrs: { type: 6, createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 1 && _vm.orderDetail.collageId != 0
                ? _c("StatusSix", {
                    attrs: { type: 1, createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 2 && _vm.orderDetail.collageId != 0
                ? _c("StatusSix", {
                    attrs: { type: 2, createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 3 && _vm.orderDetail.collageId != 0
                ? _c("StatusSix", {
                    attrs: { type: 3, createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 4 && _vm.orderDetail.collageId != 0
                ? _c("StatusSix", {
                    attrs: {
                      receiveTime: _vm.orderDetail.receiveTime,
                      type: 4,
                      createTime: _vm.orderDetail.createTime
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 5 && _vm.orderDetail.collageId != 0
                ? _c("StatusSix", {
                    attrs: { type: 5, createTime: _vm.orderDetail.createTime }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.orderDetail.collageId != 0 && _vm.orderDetail.state != 1
          ? _c("div", { staticClass: "groupBuying" }, [
              _c("div", { staticClass: "groupBuyTit" }, [_vm._v("拼团信息")]),
              _vm._v(" "),
              _c("div", { staticClass: "groupBuyBox" }, [
                _vm.groupData.state == 0
                  ? _c("div", { staticClass: "result" }, [
                      _vm._v("付款成功，待成团")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.groupData.state == 1
                  ? _c("div", { staticClass: "result" }, [
                      _vm._v("恭喜您拼团成功")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.groupData.state == 2
                  ? _c("div", { staticClass: "result0 mar-bot-20 fs18" }, [
                      _vm._v("未能按时成团，拼团失败")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.groupData.state == 0
                  ? _c("p", [
                      _vm._v(
                        _vm._s(_vm.groupData.person) + "人团，离拼团成功还差"
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.groupData.people))]),
                      _vm._v("人")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.groupData.state == 0
                  ? _c("div", { staticClass: "surplusTime" }, [
                      _vm._v("剩余时间："),
                      _c("span", { staticClass: "day time" }, [
                        _vm._v(
                          _vm._s(_vm._f("formatHours")(_vm.groupData.time))
                        )
                      ]),
                      _vm._v("时"),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(
                          _vm._s(_vm._f("formatMinutes")(_vm.groupData.time))
                        )
                      ]),
                      _vm._v("分"),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(
                          _vm._s(_vm._f("formatSeconds")(_vm.groupData.time))
                        )
                      ]),
                      _vm._v("秒")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "userList" },
                  [
                    _vm._l(_vm.groupData.personList, function(item, index) {
                      return _c("span", { key: item.id }, [
                        index === 0 ? _c("i", [_vm._v("团长")]) : _vm._e(),
                        _vm._v(" "),
                        _c("img", { attrs: { src: item.headImage, alt: "" } })
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.groupData.people, function(index) {
                      return _c(
                        "span",
                        { key: index + "n", staticClass: "noPeople iconfont" },
                        [_vm._v("\n                  \n                ")]
                      )
                    })
                  ],
                  2
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.orderDetail.state === 3 || _vm.orderDetail.state === 4
          ? _c("div", { staticClass: "logistics" }, [
              _c("p", { staticClass: "fs16 font-color-333" }, [
                _vm._v("物流信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "left" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/image/wuliuxin@2x.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v("发货方式：快递")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("物流公司：" + _vm._s(_vm.orderDetail.express))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "运单号码：" + _vm._s(_vm.orderDetail.deliverFormid)
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("物流跟踪：")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dilevery" },
                    [
                      _c(
                        "el-timeline",
                        _vm._l(_vm.dilevery, function(item, index) {
                          return _c(
                            "el-timeline-item",
                            {
                              key: index,
                              attrs: { timestamp: item.time, placement: "top" }
                            },
                            [
                              _c("div", {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#666"
                                },
                                domProps: { innerHTML: _vm._s(item.reason) }
                              })
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "desc" }, [
          _c("div", { staticClass: "receivingInfo" }, [
            _c("p", { staticClass: "title" }, [_vm._v("收货信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", [
                _vm._v(
                  "收货地址：" +
                    _vm._s(_vm.orderDetail.receiveAdress) +
                    _vm._s(_vm.orderDetail.address)
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("收货人：" + _vm._s(_vm.orderDetail.receiveName))
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("收货电话：" + _vm._s(_vm.orderDetail.receivePhone))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "storeInfo" }, [
            _c("p", { staticClass: "title" }, [_vm._v("卖家信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", [
                _vm._v("店铺名称：" + _vm._s(_vm.orderDetail.shopName))
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("联系电话：" + _vm._s(_vm.orderDetail.chargePersonPhone))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "orderInfo" }, [
            _c("p", { staticClass: "title" }, [_vm._v("订单信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", [
                _vm._v("订单号：" + _vm._s(_vm.orderDetail.orderFormid))
              ]),
              _vm._v(" "),
              _vm.orderDetail.paymentState == 1
                ? _c("p", [
                    _vm._v("支付渠道：" + _vm._s(_vm.orderDetail.paymentMode))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.paymentState == 1
                ? _c("p", [
                    _vm._v("交易号：" + _vm._s(_vm.orderDetail.transactionId))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _vm._v("创建时间：" + _vm._s(_vm.orderDetail.createTime))
              ]),
              _vm._v(" "),
              _vm.orderDetail.paymentState == 1
                ? _c("p", [
                    _vm._v("付款时间：" + _vm._s(_vm.orderDetail.paymentTime))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.state == 4
                ? _c("p", [
                    _vm._v("成交时间：" + _vm._s(_vm.orderDetail.receiveTime))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [_vm._v("备注：" + _vm._s(_vm.orderDetail.remark))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "productInfo" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.orderDetail.skus, function(pro, idx) {
                return _c("div", { key: idx, staticClass: "bottom" }, [
                  _c("div", { staticClass: "big" }, [
                    _c("img", { attrs: { src: pro.image, alt: "" } }),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(pro.productName))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "flex-direction": "column" } },
                    _vm._l(pro.values, function(text, ins) {
                      return _c("p", { key: ins }, [_vm._v(_vm._s(text))])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.orderDetail.state == 1
                    ? _c("div", [_vm._v("待付款")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderDetail.state == 2
                    ? _c("div", [_vm._v("待发货")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderDetail.state == 3
                    ? _c("div", [_vm._v("待收货")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderDetail.state == 4
                    ? _c("div", [_vm._v("已完成")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderDetail.state == 5
                    ? _c("div", [_vm._v("已关闭")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderDetail.state == 6
                    ? _c("div", [_vm._v("待成团")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(pro.number))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "font-color-FF7 fs-bold" }, [
                    _vm._v("¥" + _vm._s(pro.price))
                  ])
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "settlement" }, [
            _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "left" }, [
                _c("p", [
                  _vm._v("商品总价："),
                  _c(
                    "span",
                    { staticClass: "right", staticStyle: { color: "#FF7800" } },
                    [_vm._v("¥" + _vm._s(_vm.orderDetail.orderPrice))]
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("运费："),
                  _c("span", { staticClass: "right" }, [
                    _vm._v("¥" + _vm._s(_vm.orderDetail.logisticsPrice))
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("平台优惠："),
                  _c("span", { staticClass: "right" }, [
                    _vm._v("-¥" + _vm._s(_vm.orderDetail.discountPrice))
                  ])
                ]),
                _vm._v(" "),
                _vm.orderDetail.paymentState == 0
                  ? _c("p", { staticClass: "mar-top-20" }, [
                      _vm._v("需付款："),
                      _c(
                        "span",
                        {
                          staticClass: "right mar-top-20",
                          staticStyle: { color: "#FF7800" }
                        },
                        [_vm._v("¥" + _vm._s(_vm.orderDetail.price))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderDetail.paymentState == 1
                  ? _c("p", { staticClass: "mar-top-20" }, [
                      _vm._v("实付款："),
                      _c(
                        "span",
                        {
                          staticClass: "right",
                          staticStyle: { color: "#FF7800" }
                        },
                        [_vm._v("¥" + _vm._s(_vm.orderDetail.price))]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.closeOrderDialog,
            width: "30%",
            "before-close": _vm.closeOrderBtn
          },
          on: {
            "update:visible": function($event) {
              _vm.closeOrderDialog = $event
            }
          }
        },
        [
          _c("span", [_vm._v("是否取消该订单?")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.closeOrderDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.cancelOrder } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.inviteDialog,
            width: "30%",
            "before-close": _vm.inviteDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.inviteDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "inviteDialog" }, [
            _c("div", { staticClass: "inviteTit" }, [_vm._v("邀请好友")]),
            _vm._v(" "),
            _c("div", { staticClass: "imgCode" }, [
              _c("img", { attrs: { src: _vm.share.qrcode, alt: "" } })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "weChat",
          attrs: {
            visible: _vm.weChatDialog,
            "before-close": _vm.handleClose,
            center: "",
            width: "25%"
          },
          on: {
            "update:visible": function($event) {
              _vm.weChatDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "weChatBox" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "18px",
                  color: "#000000",
                  padding: "0 20px"
                }
              },
              [
                _vm._v(
                  "\n          请使用具有扫码支付功能的APP完成支付（支持微信、支付宝、云闪付等APP）\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "32px",
                  color: "#000000",
                  width: "100%",
                  "text-align": "center"
                }
              },
              [_vm._v("￥" + _vm._s(_vm.payInfo.money))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "qCode" }, [
              _c("img", { attrs: { src: _vm.payInfo.url, alt: "" } }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: require("../../assets/images/weiXintit.png"),
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "weChatInfo" }, [
              _c("img", {
                attrs: {
                  src: require("../../assets/images/imgPay.png"),
                  alt: ""
                }
              })
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("span", { staticClass: "big" }, [_vm._v("商品")]),
      _vm._v(" "),
      _c("span", [_vm._v("商品属性")]),
      _vm._v(" "),
      _c("span", [_vm._v("状态")]),
      _vm._v(" "),
      _c("span", [_vm._v("数量")]),
      _vm._v(" "),
      _c("span", [_vm._v("单价")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-328b7750", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-328b7750","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/orderDetail/index.vue
// module id = null
// module chunks = 